/**
 * #233654 — kiểm nhanh link SẢN PHẨM Shopee ngay lúc người dùng dán (phản hồi tức thì).
 *
 * Đây CHỈ là bản kiểm phía giao diện cho nhanh — nguồn tin cậy vẫn là server
 * (`shopee-link.util.ts`, `POST/PATCH /supplier-materials` tự kiểm lại). Giữ 2 bên cùng luật.
 * KHÔNG gọi API Shopee ở đây.
 */

const SHOPEE_HOSTS = [
  'shopee.vn', 'shopee.com', 'shopee.sg', 'shopee.co.id',
  'shopee.co.th', 'shopee.com.my', 'shopee.ph', 'shopee.tw',
];
const SHORT_HOSTS = ['s.shopee.vn', 'shp.ee'];

const PRODUCT_SUFFIX_RE = /-i\.(\d+)\.(\d+)(?:$|[/?#])/;
const PRODUCT_PATH_RE = /^\/product\/(\d+)\/(\d+)(?:$|[/?#])/;

const stripWww = (h) => h.replace(/^www\./, '').toLowerCase();

export function parseShopeeLink(raw) {
  const text = (raw ?? '').trim();
  const base = { kind: 'NOT_SHOPEE', url: null, shopId: null, itemId: null, message: null };
  if (!text) return { ...base, message: 'Chưa nhập link' };

  let u;
  try {
    u = new URL(text.startsWith('http') ? text : `https://${text}`);
  } catch {
    return { ...base, message: 'Không phải một đường link hợp lệ' };
  }
  if (u.protocol !== 'http:' && u.protocol !== 'https:') {
    return { ...base, message: 'Link phải bắt đầu bằng http:// hoặc https://' };
  }

  const host = stripWww(u.host);

  if (SHORT_HOSTS.includes(host)) {
    return {
      kind: 'SHORT',
      url: u.toString(),
      shopId: null,
      itemId: null,
      message: 'Link rút gọn — vẫn mở được, nhưng không tách được mã sản phẩm.',
    };
  }

  const isShopee = SHOPEE_HOSTS.some((d) => host === d || host.endsWith(`.${d}`));
  if (!isShopee) return { ...base, message: `"${u.host}" không phải trang Shopee` };

  const byPath = PRODUCT_PATH_RE.exec(u.pathname);
  if (byPath) {
    return {
      kind: 'PRODUCT',
      url: `https://${host}/product/${byPath[1]}/${byPath[2]}`,
      shopId: byPath[1],
      itemId: byPath[2],
      message: null,
    };
  }

  const bySuffix = PRODUCT_SUFFIX_RE.exec(u.pathname);
  if (bySuffix) {
    return {
      kind: 'PRODUCT',
      url: `https://${host}${u.pathname}`,
      shopId: bySuffix[1],
      itemId: bySuffix[2],
      message: null,
    };
  }

  return {
    kind: 'NOT_PRODUCT',
    url: null,
    shopId: null,
    itemId: null,
    message:
      'Đây là link Shopee nhưng KHÔNG phải link 1 sản phẩm (có thể là trang shop, tìm kiếm hoặc danh mục). '
      + 'Mở đúng sản phẩm rồi bấm Chia sẻ → Sao chép liên kết.',
  };
}

export function isUsableShopeeLink(raw) {
  const k = parseShopeeLink(raw).kind;
  return k === 'PRODUCT' || k === 'SHORT';
}

/** Rút gọn link cho vừa 1 dòng bảng/thẻ. */
export function shortenShopeeLink(url, max = 44) {
  if (!url) return '';
  const s = String(url).replace(/^https?:\/\//, '');
  return s.length <= max ? s : `${s.slice(0, max - 1)}…`;
}
